import React from 'react';

interface UpTickProps {
  colorCode?: string;
  width?: number;
  height?: number;
  className?: string;
}

const UpTick: React.FC<UpTickProps> = ({
  width = 10,
  height = 6,
  colorCode = '#596C85',
  className = '',
}): JSX.Element => (
  <svg
    width={width}
    className={`rotate-180 ${className}`}
    height={height}
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.83712 5.5028C1.16307 5.82646 1.68939 5.82553 2.0142 5.50072L5.24336 2.27156L8.48054 5.50169C8.80529 5.82573 9.33115 5.82544 9.65554 5.50104C9.98019 5.1764 9.98019 4.65005 9.65554 4.3254L5.83262 0.502481C5.50718 0.177044 4.97954 0.177044 4.65411 0.502481L0.835034 4.32155C0.508602 4.64799 0.509537 5.17752 0.83712 5.5028Z"
      fill={colorCode}
    />
  </svg>
);

export { UpTick };
